var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('div',[_c('ProductAddAction',{attrs:{"acc-product-id":_vm.accProductId},on:{"product-added":_vm.onProductAdded}})],1),_c('div',[_c('ProductList',{ref:"productList",attrs:{"acc-product-id":_vm.accProductId},on:{"change":function($event){return _vm.$emit('refresh')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }